import { Locale } from 'date-fns';
import { ru } from 'date-fns/locale';
import { ELanguage } from '../../types/lang';

export const locales: Record<ELanguage, Locale> = { ru };

